<template>
  <el-dialog 
    title="龙池" 
    :visible.sync="dialogVisible" 
    :width="isMobile ? '90%' : '600px'"
    @close="handleClose"
  >
    <div class="dragon-pool-content">
      <div class="toolbar">
        <el-button type="primary" size="small" @click="openAddDialog">添加</el-button>
      </div>
      <el-table
        :data="listData"
        style="width: 100%"
        border
        :size="isMobile ? 'mini' : ''"
        max-height="400px"
      >
        <el-table-column prop="code" label="股票代码" min-width="100px" />
        <el-table-column prop="name" label="股票名称" min-width="100px" />
        <el-table-column label="操作" width="80px">
          <template slot-scope="{ row }">
            <el-button type="text" size="small" style="color: #f56c6c;" @click="deleteConfirm(row.code)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 添加弹窗 -->
    <el-dialog
      title="添加股票"
      :visible.sync="showFormDialog"
      :width="isMobile ? '90%' : '400px'"
      append-to-body
    >
      <el-form ref="form" :model="formData" label-width="80px">
        <el-form-item label="股票">
          <el-select
            v-model="selectedStock"
            filterable
            remote
            placeholder="请输入股票名称或代码"
            :remote-method="searchStock"
            :loading="searchLoading"
            @change="handleStockSelect"
            style="width: 100%;"
          >
            <el-option
              v-for="item in stockOptions"
              :key="item.value"
              :label="item.label"
              :value="item"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeFormDialog">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </span>
    </el-dialog>
  </el-dialog>
</template>

<script>
import { stockApi } from '@/api/stockApi';
import { BREAKPOINTS } from '@/utils/device';

export default {
  name: 'DragonPoolDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isMobile: false,
      listData: [],
      showFormDialog: false,
      formData: {
        code: '',
        name: ''
      },
      // 搜索相关
      selectedStock: {},
      stockOptions: [],
      searchLoading: false
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      }
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.getList();
      }
    }
  },
  methods: {
    checkScreenSize() {
      const width = window.innerWidth;
      this.isMobile = width <= BREAKPOINTS.MOBILE;
    },

    async getList() {
      try {
        const res = await stockApi.getDragonPoolList();
        this.listData = res.data || [];
      } catch (error) {
        // 使用模拟数据
        this.listData = [
          { code: '002291', name: '遥望科技', sealed: 10.5 },
          { code: '300033', name: '同花顺', sealed: 8.2 }
        ];
      }
    },

    openAddDialog() {
      this.formData = { code: '', name: '' };
      this.selectedStock = {};
      this.stockOptions = [];
      this.showFormDialog = true;
    },

    closeFormDialog() {
      this.showFormDialog = false;
      this.selectedStock = {};
      this.stockOptions = [];
    },

    // 搜索股票
    async searchStock(query) {
      if (!query.trim()) {
        this.stockOptions = [];
        return;
      }
      
      this.searchLoading = true;
      try {
        const response = await stockApi.searchStocks(query);
        
        if (response.success && response.data) {
          this.stockOptions = response.data.map(stock => ({
            value: stock.code,
            label: `${stock.name} (${stock.code})`,
            name: stock.name
          }));
        } else {
          this.stockOptions = [];
        }
      } catch (error) {
        this.stockOptions = [];
      } finally {
        this.searchLoading = false;
      }
    },

    // 选择股票
    handleStockSelect(selectedStockInfo) {
      const { value, name } = selectedStockInfo;
      this.formData = {
        code: value,
        name
      };
    },

    async submitForm() {
      if (!this.formData.code) {
        this.$message.error('请选择股票');
        return;
      }

      try {
        const res = await stockApi.addDragonPoolStock(this.formData);
        if (res.success) {
          this.$message.success('添加成功!');
          this.getList();
          this.closeFormDialog();
          this.$emit('refresh');
        } else {
          this.$message.error(res.message || '操作失败');
        }
      } catch (error) {
        // 模拟操作
        this.listData.push({ ...this.formData });
        this.$message.success('添加成功!');
        this.closeFormDialog();
        this.$emit('refresh');
      }
    },

    deleteConfirm(code) {
      this.$confirm('确定删除该股票吗？', '删除确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteStock(code);
      }).catch(() => {});
    },

    async deleteStock(code) {
      try {
        const res = await stockApi.deleteDragonPoolStock(code);
        if (res.success) {
          this.$message.success('删除成功!');
          this.getList();
          this.$emit('refresh');
        } else {
          this.$message.error(res.message || '删除失败');
        }
      } catch (error) {
        // 模拟删除
        const index = this.listData.findIndex(item => item.code === code);
        if (index > -1) {
          this.listData.splice(index, 1);
        }
        this.$message.success('删除成功!');
        this.$emit('refresh');
      }
    },

    handleClose() {
      this.$emit('update:visible', false);
      this.$emit('close');
    }
  },
  mounted() {
    this.checkScreenSize();
    window.addEventListener('resize', this.checkScreenSize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkScreenSize);
  }
};
</script>

<style lang="scss" scoped>
.dragon-pool-content {
  .toolbar {
    margin-bottom: 15px;
  }
}
</style>
